import React, { useEffect, useState } from 'react';
import '../../styles/table-main/main.css';
import { getAllTendersInfo } from '../../Services/AllAPIs';
import LoadingSpinner from '../LoadingSpinner';

const Main = () => {

    const [loader, setLoader] = useState(true);
    const [tenders, setTenders] = useState([]);
    const [error, setError] = useState(null);

    // Fetch tenders data
    const getTenders = () => {
        getAllTendersInfo()
            .then((res) => {
                // console.log('tenders--->', res.data.news);
                const tendersData = Object.values(res.data.news || {});
                setTenders(tendersData);
                setLoader(false);
            })
            .catch((error) => {
                console.error(error);
                setError("An error occurred while fetching tender data.");
                setLoader(false);
            });
    };

    useEffect(() => {
        getTenders();
    }, []);


    // Function to format date as DD/MM/YYYY
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    return (
        <div id='tableMain'>
            <div className="table-inner-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">

                        {loader && <LoadingSpinner />}
                        {error && <div className="error">{error}</div>}

                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading mb-2">Tenders</h2>
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th>Posted Date</th>
                                                <th>Download</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tenders.length > 0 ? (
                                                tenders.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.title}</td>
                                                        <td>{formatDate(item.created_at)}</td>
                                                        <td>
                                                            <a
                                                                href={item.url}
                                                                className="btn btn-primary btn-download"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3">No tenders available.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
